import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'talent.seek.com.au',
    clientId: '8msSXVB0z0v7gN34Y5j0j5Sxn72KTFBB',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://talent.seek.com.au/contactus/',
    },
    siteName: siteNames.employer.seek.au,
    zone: getZoneFromSite(siteNames.employer.seek.au),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=talent_seek_com_au.js.map